import { Button, Form, Input, message } from "antd";
import { useState } from "react";
import { BaseApi } from "../base.api";
import { useNavigate, useParams } from "react-router-dom";

const AllowAddSource = () => {
    const [source,setSource] = useState("")
    const {id} = useParams()
    const navigate = useNavigate()
    console.log(id);
    
    const deleteSource = async()=>{
        const response = await new BaseApi().postData(`/common-service/v1/allowed-source/company/${id}`,{name:source})
        if(response?.data == true){
            message.success("created source")
            navigate(`/main/companies/${id}`)
            return
        }
        message.error("error")
    }
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "57vh",
          padding: "20px",
        }}
      >
        <div
          style={{
            width: 400,
            border: "1px solid #f0f0f0",
            padding: 40,
            borderRadius: 8,
            boxShadow: "0 2px 3px rgba(0,0,0,0.1)",
          }}
        >
          <h3>New Source</h3>
          <Form
            // validateMessages={validateMessages}

            layout="vertical"
            // form={form}
          >
            <Form.Item label="Name" name = "name" rules={[{ required: true }]}>
              <Input placeholder="Add new name..." value={source} onChange={(e)=>setSource(e.target.value)} />
            </Form.Item>
            <Form.Item label={null}>
              <Button onClick={deleteSource} type="primary" htmlType="submit">
                Create
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AllowAddSource;
